const localeModules: Record<string, Record<string, () => Promise<any>>> = {
  en: import.meta.glob('@/assets/locales/en/*.json'),
  no: import.meta.glob('@/assets/locales/no/*.json')
};

export async function loadLocaleMessages(locale: string): Promise<Record<string, any>> {
  const modules = localeModules[locale];
  if (!modules) {
    throw new Error(`Locale ${locale} not supported.`);
  }

  const messages: Record<string, any> = {};
  const imports = [];

  for (const path in modules) {
    imports.push(
      modules[path]().then(module => {
        Object.assign(messages, module.default);
      })
    );
  }

  await Promise.all(imports);
  return messages;
}
